import { Injectable } from '@angular/core';
import { ArrivalChangeEvent } from '../../models/dto/arrival/gates-monitoring/arrival-change-event.dto';
import { GateChangesSocket } from '../../sockets/gates/gate-changes.socket';

@Injectable()
export class GateGatewayService {
  constructor(private readonly socket: GateChangesSocket) {}

  subscribeGateChanges = (idGate: string) => {
    this.socket.emit('gate.update.subscribe', idGate);
  };

  unSubscribeGateChanges = (idGate: string) => {
    this.socket.emit('gate.update.unsubscribe', idGate);
  };

  getGateChanges = () => {
    return this.socket.fromEvent<ArrivalChangeEvent>('gate.updated');
  };

  listenDisconnections = () => {
    this.socket.on('disconnect', (reason: any) => console.log(reason));
  };
}
